import { DistAngleActions } from 'src/app/model/map-actions/dist-angle-actions';
import { ViewStackComponent } from '../../view-stack/view-stack.component';
import { FiniteStateMachine } from './../../../model/FiniteStateMachine';
import { AfterViewInit, Component, Input, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { SLLayer } from 'src/app/model/sl-layer';
import { SelectionProxy } from 'src/app/model/selection-proxy';
import * as turf from '@turf/turf';
import { PixoSpatialCoord, SpatialCoord } from 'src/app/model/Pixospatial';
import { DrawPaneComponent } from '../../draw-pane/draw-pane.component';
export type BearingMode = 'north' | 'south' | 'east' | 'west' | 'prev' | 'next' | 'current' | 'snap-seg' | 'snap-pt' | 'from-snap-pt' | 'from-snap-seg';
@Component({
  selector: 'app-dist-angle-tools',
  templateUrl: './dist-angle-tools.component.html',
  styleUrls: ['./dist-angle-tools.component.scss']
})
export class DistAngleToolsComponent implements AfterViewInit {
  private distAngleTools = new FiniteStateMachine(this, [
    'noState',
    'isFromSel:dist-angles-sel-vertex',
    'isAddVertex:dist-angles-add-vertex',
    'isRelSnap:dist-angles-add-rel-snap'
  ])
  public noState = true;
  public isFromSel = false;
  public isAddVertex = false;
  public isRelSnap = false;
  public meterDistance: number = 0;
  public bearingLength: number = 0;
  public angle: number = 0;

  public bearing: number = 0;
  public vertexDirection: 'from' | 'to' = 'to';
  public get hasSelSnap() {
    return !!this.currentSnapPt || !!this.currentSnapSeg;
  }
  public currentView = '';
  public fromTo: 'from' | 'to' = 'from';
  private _readyToAct: boolean = false;
  public readyToAct: boolean = false;
  public drawPane: DrawPaneComponent;

  private _currentVertex?: any
  @Input()
  public set currentVertex(v: any) {
    this._currentVertex = v;
  }
  public get currentVertex(): any {
    return this._currentVertex;
  }

  public currentState: string = 'noState';


  private _currentSegment?: any;

  public get hasSelVertex(): boolean {
    return !!this.currentVertex;
  }

  @Input()
  set currentSegment(v: any) {
    this._currentSegment = v;

  }
  get currentSegment(): any {
    return this._currentSegment;
  }



  @Input()
  public currentSnapPt?;
  @Input()
  public currentSnapSeg?;

  @ViewChild('views') views: ViewStackComponent;

  private _snapLayer: SLLayer;

  @Input()
  public set snapLayer(layer: SLLayer) {
    this._snapLayer = layer;
    this.SetupDrawPane();
    // this.Update();
  }
  public get snapLayer(): SLLayer {
    return this._snapLayer;
  }

  private _drawPaneChanges?: SelectionProxy;
  @Input()
  set drawPaneChanges(changes: SelectionProxy) {
    if (!!this._drawPaneChanges) return;
    if (!changes) return;
    this._drawPaneChanges = changes;
    this._drawPaneChanges.RegisterListener('dist-angle-tools', () => {
      this.UpdateSelections();
    })
    this.bearingMode = this.bearingMode;
  }
  private _bearingMode: BearingMode = 'north';
  public set bearingMode(mode: BearingMode) {

    switch (mode) {
      case 'south':
        this.snappable = false;
        this.bearing = 180;
        this.bearingLength = 0;
        break;
      case 'east':
        this.snappable = false;
        this.bearing = 90;
        this.bearingLength = 0;
        break;
      case 'west':
        this.snappable = false;
        this.bearing = 270;
        this.bearingLength = 0;
        break;
      case 'next':
        this.snappable = false;
        if (this.hasToSeg) {
          // get next seg and get its bearing
          const from = this.currentVertex.toSeg.from.coord;
          const to = this.currentVertex.toSeg.to.coord;
          if (this.vertexDirection === 'from') {
            this.bearing = this.drawPane?.spatialContext.Bearing(from, to);
          } else {
            this.bearing = this.drawPane?.spatialContext.Bearing(to, from);
          }
          this.bearingLength = this.drawPane?.spatialContext.CoordDistance(from, to);
        } else {
          this.bearing = 0;
        }
        break;
      case 'snap-seg':
        this._bearingMode = 'snap-seg';
        this.snappable = true;
        if (!!this.currentSnapSeg?.length) {
          const from = this.currentSnapSeg[0].from;
          const to = this.currentSnapSeg[0].to;
          if (this.vertexDirection === 'from') {
            this.bearing = this.drawPane?.spatialContext.Bearing(from, to);
          } else {
            this.bearing = this.drawPane?.spatialContext.Bearing(to, from);
          }
          this.bearingLength = this.drawPane?.spatialContext.CoordDistance(from, to);
        }
        break;
      case 'snap-pt':
        this._bearingMode = 'snap-pt';
        this.snappable = true;


        if (this.currentSnapPt?.length) {
          const from = this.currentVertex.coord;
          const to = this.currentSnapPt[0].coord;
          if (this.vertexDirection === 'from') {
            this.bearing = this.drawPane?.spatialContext.Bearing(from, to);
          } else {
            this.bearing = this.drawPane?.spatialContext.Bearing(to, from);
          }
          this.bearingLength = this.drawPane?.spatialContext.CoordDistance(from, to);

        }
        break;
      case 'from-snap-pt':
        this._bearingMode = 'from-snap-pt';
        this.snappable = true;
        if (this.currentSnapPt?.length) {
          const from = this.currentSnapPt[0].coord;
          const to = this.currentVertex.coord;
          if (this.vertexDirection === 'from') {
            this.bearing = this.drawPane?.spatialContext.Bearing(from, to);
          } else {
            this.bearing = this.drawPane?.spatialContext.Bearing(to, from);
          }
          this.bearingLength = this.drawPane?.spatialContext.CoordDistance(from, to);
        }
        break;
      case 'prev':
        this.snappable = false;

        if (this.hasFromSeg) {
          const from = this.currentVertex.fromSeg.from.coord;
          const to = this.currentVertex.fromSeg.to.coord;
          if (this.vertexDirection === 'from') {
            this.bearing = this.drawPane?.spatialContext.Bearing(from, to);
          } else {
            this.bearing = this.drawPane?.spatialContext.Bearing(to, from);
          }
          this.bearingLength = this.drawPane?.spatialContext.CoordDistance(from, to);
        } else {
          this.bearing = 0;
        }
        break;
      case 'current':
        this.snappable = false;
        if (this.hasSelSegment) {
          const from = this.currentSegment.from.coord;
          const to = this.currentSegment.to.coord;
          if (this.vertexDirection === 'from') {
            this.bearing = this.drawPane?.spatialContext.Bearing(from, to);
          } else {
            this.bearing = this.drawPane?.spatialContext.Bearing(to, from);
          }
          this.bearingLength = this.drawPane?.spatialContext.CoordDistance(from, to);
        } else {
          this.bearing = 0;

        }
        break;
      default:
      case 'north':
        this.snappable = false;
        this.bearing = 0;
        break;
    }
    this._bearingMode = mode;

    if (this.bearing === 0) {
      if (this.snappable) return;
      if (this._bearingMode !== 'north') this._bearingMode = 'north';
      this.bearingLength = 0;
    }


  }
  public get bearingMode(): BearingMode {
    return this._bearingMode;
  }
  public get hasFromSeg(): boolean {
    if (!this.currentVertex) return false;
    return !!this.currentVertex.fromSeg;

    return false;
  }
  public get hasToSeg(): boolean {
    if (!this.currentVertex) return false;
    return !!this.currentVertex.toSeg;
  }
  public get hasSelSegment(): boolean {
    return !!this.currentSegment;
  }
  public get hasOneDrawnPoint(): boolean {
    return this.drawPane?.GetSelectedFeature()?.points?.length >= 1;
  }
  public get isGeometryFriendly(): boolean {
    if (this.drawPane?.GetSelectedFeature()?.type === 'point') {
      return !this.hasOneDrawnPoint;
    }
    return true;
  }
  private _snappable: boolean = false;
  private set snappable(val: boolean) {
    if (this._snappable === val) return;
    this._snappable = val;
    if (this._snappable) {
      this.drawPane.SnapOn();
    } else {
      this.ClearSnaps();
    }
  }
  private get snappable(): boolean {
    return this._snappable
  }

  private _ignoreMode: boolean = false;
  private _ready: boolean = false;

  public get requiredDrawMode() {
    if (this.isAddVertex) return 'snap';
    if (this.isFromSel) return 'snap';
    if (this.isRelSnap) return 'snap';
    return '';
  }
  constructor(private cdr: ChangeDetectorRef) {
    this.distAngleTools.RegisterHandlers(
      (params: any) => {
        this.currentState = params.value;
        if (!!params.isOn) {
          this.SetView(params.value);
        } else {
          this.SetView('noState');
        }
      },
      () => {
        this.currentState = 'noState'
        this.SetView('');
      }
    );
    DistAngleActions.RegisterComponent('dist-angle', this);
  }
  ClearSnaps() {
    if (!this.drawPane) return;
    if (this.isAddVertex || this.isFromSel || this.isRelSnap) {
      if (this.drawPane.drawMode === 'snap') return;
      this.drawPane.SnapOff();
    }
  }
  ngAfterViewInit(): void {
    this.SetView(this.currentState)
    this._ready = true;
  }
  SetupDrawPane() {
    if (!this.snapLayer?.map?.component?.drawPane) return;
    this.drawPane = this.snapLayer.map.component.drawPane;
  }
  public SetTool(tool: string, isOn: boolean) {
    this.distAngleTools.SetValue(tool, isOn);
    this.CheckReadiness();
  }
  public CheckReadiness() {
    this.UpdateViews();
    if (this.isFromSel) {
      this.readyToAct = this.hasSelVertex;
      return;
    }
    if (this.isAddVertex) {
      this.readyToAct = this.hasSelVertex || this.hasSelSegment;
      return;
    }

    if (this.isRelSnap) {
      this.readyToAct = this.hasSelSnap;
      return;
    }
  }
  public noSnaps = true;
  public noSnapLayer = true;
  public SetView(viewName) {
    if (!this.views) return;
    this.views.SetView(viewName);
    this.UpdateViews();
    this.UpdateSelections();
    this.bearingMode = this._bearingMode;
  }
  UpdateViews() {
    const viewName = this.views.currentView.viewName;
    switch (viewName) {
      case 'dist-angles-sel-vertex':
        break;
      case 'dist-angles-add-vertex':
        break;
      case 'dist-angles-add-rel-snap':
        this.drawPane?.SnapOn();
        this.Refresh(true);
        break;
      case 'noSnaps':
      case 'no-snap-layer':
        break;
      default:
      case 'noState':
        this.views.SetView('noState');
        break;

    }
  }
  UpdateSelections() {
    if (!!this._drawPaneChanges) {
      this._currentSegment = this._drawPaneChanges.GetProperty('segment');
      this._currentVertex = this._drawPaneChanges.GetProperty('vertex');
      this.currentSnapPt = this._drawPaneChanges.GetProperty('snapVertex');
      this.currentSnapSeg = this._drawPaneChanges.GetProperty('snapSegment');
      const snapGeomChange = this._drawPaneChanges.GetProperty('snapGeomChange');
      if (snapGeomChange) {
        this.Reset();
        return;
        const wasNoSnaps = this.noSnaps;
        const noSnaps = !this.drawPane?.GetSnaps()?.points?.points?.length;
        if (!!noSnaps && !wasNoSnaps) {
          this.noSnaps = noSnaps;
          this.readyToAct = false;
          this.CheckReadiness();
          this.drawPane.SnapOn();

          this.Refresh(true);


        }
      }
      this.noSnapLayer = !this.drawPane?.GetSnaps().points.points.length;
    }
    this.CheckReadiness();

    if (this.noState) return;
    if (!this._ignoreMode) {
      if (this.drawPane?.drawMode !== 'snap') {
        if (['snap-seg', 'snap-pt'].indexOf(this._bearingMode) === -1) {
          if (this.isRelSnap || this.isFromSel || this.isAddVertex) {
            //this.drawPane?.DeselectSnaps();
          }
        }
      }
      this.bearingMode = this.bearingMode;
      this.snappable = this._snappable;
      this.Refresh();
    }

  }
  GetFromTo(from: PixoSpatialCoord, to: PixoSpatialCoord) {
    return this.vertexDirection === 'to' ? [from, to] : [to, from];
  }
  MoveVertex() {
    if (!this.isFromSel) return;
    if (!this.currentVertex) return;
    let meterDistance = this.meterDistance;
    let centerLngLat = this.currentVertex.coord.spatial as SpatialCoord;
    let bearing = this.bearing;
    if (meterDistance === 0) {
      if (this.currentVertex.fromSeg?.from && (this._bearingMode === 'prev')) {
        const [from, to] = this.GetFromTo(
          this.currentVertex.fromSeg.from.coord,
          this.currentVertex.fromSeg.to.coord);
        this.drawPane.spatialContext.RotateCoords(to, from, this.angle);
        this.currentVertex.fromSeg.to.updateUI();
        this.angle = 0;
        this.bearingMode = this._bearingMode;
        return;

      }
      if (this.currentVertex.toSeg?.to && (this._bearingMode === 'next')) {
        const [from, to] = this.GetFromTo(
          this.currentVertex.toSeg.from.coord,
          this.currentVertex.toSeg.to.coord);
        this.drawPane.spatialContext.RotateCoords(from, to, this.angle);
        this.currentVertex.toSeg.from.updateUI();
        this.angle = 0;
        this.bearingMode = this._bearingMode;
        return;
      }

    }
    if (this.vertexDirection === 'from') {
      bearing -= 180;
    }
    const center = turf.point([centerLngLat.lng, centerLngLat.lat]);
    const distance = meterDistance / 1000;
    const angle = bearing + this.angle;
    const newPoint = turf.destination(center, distance, angle, { units: 'kilometers' });
    const [lng, lat] = newPoint.geometry.coordinates;
    this.currentVertex.coord.UpdateSpatial(lng, lat);
    this.currentVertex.updateUI();

  }
  AddVertex() {
    if (!this.isAddVertex) return;
    if (!this.currentVertex) return;
    const centerLngLat = this.currentVertex.coord.spatial;
    const center = turf.point([centerLngLat.lng, centerLngLat.lat]);
    const distance = this.meterDistance / 1000;
    let bearing = this.bearing;
    if (this.vertexDirection === 'from') {
      bearing -= 180;
    }
    const angle = bearing + this.angle;
    const newPoint = turf.destination(center, distance, angle, { units: 'kilometers' });
    const pixo = this.drawPane.spatialContext;
    const coord = pixo.PixoSpatialCoord(pixo.SpatialCoord({ lng: newPoint.geometry.coordinates[0], lat: newPoint.geometry.coordinates[1] }));
    this.drawPane.AddVertexFromCoord(coord);
    this.drawPane.drawMode = 'feature';
  }
  AddRelSnap() {
    if (!this.isRelSnap) return;
    if (!this.currentVertex || !!this.currentSegment) return;
    if (!this.hasSelSnap) return;
    if (!!this.currentSnapPt) {
      const nearest = this.currentSnapPt[0].coord;
      const centerLngLat = nearest.spatial;
      const center = turf.point([centerLngLat.lng, centerLngLat.lat]);
      let bearing = this.bearing;
      if (this.vertexDirection === 'from') {
        bearing -= 180;
      }
      const angle = bearing + this.angle;

      const newPoint = turf.destination(center, this.meterDistance / 1000.0, angle, { units: 'kilometers' });
      const pixo = this.drawPane.spatialContext;
      const coord = pixo.PixoSpatialCoord(pixo.SpatialCoord({ lng: newPoint.geometry.coordinates[0], lat: newPoint.geometry.coordinates[1] }));
      this.drawPane.AddVertexFromCoord(coord);
      this.drawPane.drawMode = 'feature';
      return;
    }
    if (!!this.currentSnapSeg) {
      const vCoord = this.currentVertex.coord;
      const nearestCoord = this.drawPane.spatialContext.GetNearestCoord(this.currentSnapSeg.from, this.currentSnapSeg.to, vCoord);
      const centerLngLat = nearestCoord.spatial;
      const center = turf.point([centerLngLat.lng, centerLngLat.lat]);
      let bearing = this.bearing;
      if (this.vertexDirection === 'from') bearing -= 180;
      const angle = bearing + this.angle;

      const newPoint = turf.destination(center, this.meterDistance / 1000.0, angle, { units: 'kilometers' });
      const pixo = this.drawPane.spatialContext;
      const coord = pixo.PixoSpatialCoord(pixo.SpatialCoord({ lng: newPoint.geometry.coordinates[0], lat: newPoint.geometry.coordinates[1] }));
      this.drawPane.AddVertexFromCoord(coord);
      this.drawPane.drawMode = 'feature';

      return;
    }

  }
  ToggleDirection() {
    this.vertexDirection = this.vertexDirection === 'from' ? 'to' : 'from';
    this.Refresh();
  }
  Reset() {
    if (this.distAngleTools.GetCurrentState() !== 'noState') {
      this.distAngleTools.SetState('noState', true);

    }
  }
  Refresh(force = false) {
    if (!this._ready) return;
    if (force) this.cdr.markForCheck();
    this.cdr.detectChanges();
  }

}
